import {
  ROMBELS_GET,
  ROMBEL_PORTALUSERS_GET,
  ROMBEL_UPDATE_PORTALUSER,
  ROMBEL_ADD,
  ROMBEL_EDIT,
  ROMBEL_GET,
  ROMBEL_DELETE,
} from './reduxConstant';

export const rombelsGet = (rombels) => {
  return {
    type: ROMBELS_GET,
    payload: {
      rombels,
    },
  };
};

export const rombelAdd = (rombel) => {
  return {
    type: ROMBEL_ADD,
    payload: {
      rombel,
    },
  };
};

export const rombelEdit = (rombel) => {
  return {
    type: ROMBEL_EDIT,
    payload: {
      rombel,
    },
  };
};

export const rombelGet = (rombel) => {
  return {
    type: ROMBEL_GET,
    payload: {
      rombel,
    },
  };
};

export const rombelPortalusersGet = (rombel) => {
  return {
    type: ROMBEL_PORTALUSERS_GET,
    payload: {
      rombel,
    },
  };
};

export const rombelUpdatePortaluser = (rombel) => {
  return {
    type: ROMBEL_UPDATE_PORTALUSER,
    payload: {
      rombel,
    },
  };
};

export const rombelDelete = (rombel) => {
  return {
    type: ROMBEL_DELETE,
    payload: {
      rombel,
    },
  };
};
